<template>
  <v-navigation-drawer
      app
      color="blackish"
      width="64"
      dark
      right
      mobile-breakpoint="600"
  >
    <v-list
        dense
        nav
        class="py-1 d-flex flex-column sidebar-list"
    >
      <v-list-item class="px-1">
      <v-list-item-avatar @click="toggleModal" style="cursor: pointer">
        <v-avatar
          color="primary"
          size="40"
          class="d-flex align-center justify-center"
          style="letter-spacing: 0;"
        >
          {{ userInitials }}
        </v-avatar>
      </v-list-item-avatar>
    </v-list-item>
      <v-list-item class="px-1" @click="toggleTheme" style="z-index: 1000;">
        <v-list-item-content>
          <v-icon>{{$vuetify.theme.dark ? icons.mdiDay : icons.mdiNight}}</v-icon>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="!hideSasMenu" class="px-1 d-flex justify-center admin-menus-item" style="z-index: 1000;">
        <scs-admin-menus ref="adminMenus"></scs-admin-menus>
      </v-list-item>
      <v-list-item :to="item.route" class="tune-item" style="z-index: 1000;">
        <v-list-item-content >
          <v-icon>{{ icons.mdiTune }}</v-icon>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {mdiWeatherNight, mdiWeatherSunset, mdiTune} from "@mdi/js";
import { adminAuthInstance } from '@/services/authService';
import '@nsftx/seven-client-sdk-admin/admin-ui';

export default {
  data() {
    return {
      item: {
        route: "working_time"
      },
      icons: {
        mdiNight: mdiWeatherNight,
        mdiDay: mdiWeatherSunset,
        mdiTune: mdiTune
      }
      // items: [
      //   {
      //     title: 'Directory',
      //     icon: 'mdi-folder',
      //   },
      //   {
      //     title: 'Assets',
      //     icon: 'mdi-briefcase',
      //   },
      // ],
    };
  },
  methods: {
    ...mapActions({"toggleAccountModal": "accounts/toggleAccountModal"}),
    toggleModal() {
      this.toggleAccountModal();
    },
    toggleTheme() {
      // Toggle Vuetify theme
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      // Save theme preference to localStorage
      localStorage.setItem("theme_dark", this.$vuetify.theme.dark);
    },
  },
  computed: {
    ...mapGetters({
      getUser: 'accounts/getUser'
    }),
    // Users who signed in with email/password have no Guards session, so the
    // admin menus widget would have nothing to render.
    hideSasMenu() {
      return localStorage.getItem('isOwnLogin') === 'true';
    },
    userInitials(){
    const u = (this.getUser && typeof this.getUser === 'object') ? this.getUser : null;

    const raw =
      u?.display_name ||
      u?.full_name ||
      u?.username ||
      u?.email ||
      '';

    if (!raw) return '';

    // Strip email domain if present
    const base = String(raw).trim().replace(/@.*/, '');

    // Split on common separators
    const parts = (base.includes(' '))
      ? base.split(/\s+/)
      : base.split(/[._-]/);

    const initials = parts
      .filter(Boolean)
      .map(p => p.charAt(0).toUpperCase());

    // Reverse order if at least 2 parts
    return initials.length > 1
      ? [initials[1], initials[0]].join('')
      : initials[0] || '';
  }
  },
  mounted() {
    this.$nextTick(() => {
      const el = this.$refs.adminMenus;
      if (el && !this.hideSasMenu) el.auth = adminAuthInstance;
    });
  }
};
</script>

<style scoped>
.sidebar-list {
  height: 100%;
}

.sidebar-list > .v-list-item {
  flex: 0 0 auto;
}

.tune-item {
  margin-top: auto;
}

::v-deep .v-avatar {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
</style>

<style>
/* Unscoped: allow admin menus widget dropdown to overflow the navigation drawer */
.v-navigation-drawer--right {
  overflow: visible !important;
}
.v-navigation-drawer--right .v-navigation-drawer__content {
  overflow: visible !important;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.admin-menus-item {
  position: relative;
}
.admin-menus-item scs-admin-menus {
  position: relative;
  z-index: 9999;
  background-color: white;
  border-radius: 7px;
}
</style>
